import React, { useEffect, useState } from 'react';
import resultState from '../Sale/Operations/SaleOrder/stateMigrate';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import Table from 'components/Table/Table';
import { currency } from 'hooks/Pipe';
import moment from 'moment';

function OrderTransactionModal(props) {
  const { model, entity, setOpen } = props;
  const [transaction, setTransaction] = useState(undefined);
  const [logs, setLogs] = useState([]);

  async function getTransaction() {
    let res = await wsGetAll(`${entity}/${model.id}/transaction`);
    if (res.success) {
      let transaction = res.data;
      let logs = res.data.logs;

      setTransaction(transaction);
      setLogs(logs);
    } else {
      window.alert(res.message);
    }
  }

  useEffect(() => {
    if (model.id === undefined) {
      setTransaction(undefined);
      setLogs([]);
      return;
    }
    getTransaction();
  }, [model, entity]);

  return (
    <ModalBase title={"Logs pedido " + (model?.id || '').toString()} model={model} setOpen={setOpen} hideSave fullWidth maxWidth="md">
      {transaction !== undefined && (
        <GridContainer>
          <GridItem xs={12}>
            {/* Cabecera */}
            {entity === 'ordm/order' ? (
              <GridContainer>
                <GridItem xs={3}>
                  <h6>id</h6>
                  <h5>{model.id}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Fecha pedido</h6>
                  <h5>{moment(model.created_at).format('DD-MM-YYYY LT')}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Vendedor</h6>
                  <h5>{model.SlpName}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Canal</h6>
                  <h5>{model.base_canal_description}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Cod Cliente</h6>
                  <h5>{model.CardCode}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Cliente</h6>
                  <h5>{model.CardName}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Importe</h6>
                  <h5>{currency(model.total_amount)}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Estado</h6>
                  <h5>
                    {model.state === 'R'
                      ? 'Retenido'
                      : model.state === 'X'
                      ? 'Normal'
                      : model.state === 'S'
                      ? 'Sin Stock'
                      : 'No definido'}
                  </h5>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer>
                <GridItem xs={3}>
                  <h6>id</h6>
                  <h5>{model.id}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Fecha pedido</h6>
                  <h5>{moment(model.date_order).format('DD-MM-YYYY LT')}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Vendedor</h6>
                  <h5>{model.SlpName}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Canal</h6>
                  <h5>{model.base_canal_description}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Cod Cliente</h6>
                  <h5>{model.CardCode}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Cliente</h6>
                  <h5>{model.CardName}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Importe</h6>
                  <h5>{currency(model.total_order)}</h5>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Estado</h6>
                  <h5>{resultState(model.state_migrate)}</h5>
                </GridItem>
              </GridContainer>
            )}
          </GridItem>
          <GridItem xs={12}>
            <Table
              tableHead={['#', 'Usuario', 'Log', 'Fecha/Hora']}
              tableData={logs.map((item, index) => {
                return [
                  index + 1,
                  item.user?.name || '-',
                  item.description,
                  moment(item.created_at).format('DD-MM-YYYY LT'),
                ];
              })}
            />
          </GridItem>
        </GridContainer>
      )}
    </ModalBase>
  );
}

export default OrderTransactionModal;
